import * as React from "react";
import {cx} from "emotion";

import "./normal-mode.scss";

import {cs}           from "@Common/react/chain-services";
import {cnv}          from "@Common/utils/arr-path";

import {addVector}      from "../../common/add-vector";
import {Dragging}       from "../../common/dragging";

export const NormalMode = ({onChangeFrame, next}) => cs(
    ["dragging", (_, next) => Dragging({next})],
    ({dragging}) => next({
        defaultMode: true,
        modFrame: dragging.active?.delta && (
            (adj) => cnv(adj, ["offset"], (pos) => (
                addVector(pos ?? {x:0,y:0}, dragging.active.delta)
            ))
        ),
        renderOverlay: ({frame}) => cs(

            ({}) => (
                <div {...{
                    className: cx("normal-mode normal-mode-20e", {dragging: dragging.active}),
                    ...dragging.handle,
                }}>
                    {dragging.renderActive({
                        onDone: (delta) => onChangeFrame((frame) => cnv(frame, ["offset"], (pos) => addVector(pos ?? {x:0,y:0}, delta))),
                    })}
                </div>
            ),
        ),
    }),
);
